@if (block.data.title) {
    @switch (block.data.styleVariant) {
        @case ('card-overlay') {
            <ng-container *ngTemplateOutlet="cardOverlayTemplate; context: { block }"></ng-container>
        }
        @case ('decorative-frame') {
            <ng-container *ngTemplateOutlet="decorativeFrameTemplate; context: { block }"></ng-container>
        }
    }
}

<ng-template #cardOverlayTemplate let-block="block">
    <section
        class="cta-banner-container"
        [ngClass]="{
            'cta-banner-container--top-border': block.data.useBorderTop,
            'cta-banner-container--stripe-overlay': block.data.applyOverlay && block.data.bgOverlay === 'stripes',
            'cta-banner-container--text-color-white': block.data.textColor === 'white',
            'cta-banner-container--text-color-black': block.data.textColor === 'black',
        }"
        [style]="`--bg: ${getBackground()}`"
        [attr.data-theme]="block.data.styleVariant">
        <div class="cta-banner-card" [class.cta-banner-card--glass]="block.data.useGlassCardStyle">
            @if (block.data.includeFgImage) {
                <img [src]="block.data.fgImage" [alt]="block.data.imgAlt" class="cta-banner-card__image" />
            }
            <div class="cta-banner-card__content">
                <h2
                    class="cta-banner-card__title"
                    [ngClass]="{
                        'cta-banner-card__title--text-color-base': block.data.headingTextColor === 'base',
                        'cta-banner-card__title--text-color-primary': block.data.headingTextColor === 'primary',
                        'cta-banner-card__title--text-color-secondary': block.data.headingTextColor === 'secondary',
                        'cta-banner-card__title--text-color-heading': block.data.headingTextColor === 'heading',
                        'cta-banner-card__title--text-color-white': block.data.headingTextColor === 'white',
                    }">
                    {{ block.data.title }}
                </h2>

                @if (block.data.description) {
                    <div
                        class="cta-banner-card__description"
                        [ngClass]="{
                            'cta-banner-card__description--text-size-small': block.data.textSize === 'small',
                            'cta-banner-card__description--text-size-normal': block.data.textSize === 'normal',
                            'cta-banner-card__description--text-size-large': block.data.textSize === 'large',
                        }"
                        [innerHTML]="block.data.description"></div>
                }
            </div>

            <a
                class="btn btn-primary cta-banner-card__link"
                [href]="block.data.ctaLink"
                [target]="block.data.isCtaExternalLink ? '_blank' : '_self'"
                [attr.aria-label]="block.data.includeAriaLabel ? block.data.ariaLabel : null"
                >{{ block.data.ctaLabel }}</a
            >
        </div>
    </section>
</ng-template>

<ng-template #decorativeFrameTemplate let-block="block">
    <section class="cta-banner-container" [attr.data-theme]="block.data.styleVariant">
        <!-- Left decorative image -->
        <div class="cta-banner__image-container cta-banner__image-container--left">
            <img class="cta-banner__image cta-banner__image--left" [src]="parseImageUrl(block.data.leftImage)" alt="" />
        </div>

        <div class="cta-banner__content">
            <h2 class="cta-banner__title">
                {{ block.data.title }}
            </h2>

            @if (block.data.description) {
                <div class="cta-banner__description" [innerHTML]="block.data.description"></div>
            }

            <a
                class="btn btn-primary cta-banner__link"
                [href]="block.data.ctaLink"
                [target]="block.data.isCtaExternalLink ? '_blank' : '_self'"
                [attr.aria-label]="block.data.includeAriaLabel ? block.data.ariaLabel : null"
                [innerText]="block.data.ctaLabel | translate"></a>
        </div>

        <!-- Right decorative image -->
        <div class="cta-banner__image-container cta-banner__image-container--right">
            <img
                class="cta-banner__image cta-banner__image--right"
                [src]="parseImageUrl(block.data.rightImage)"
                alt="" />
        </div>
    </section>
</ng-template>
